import Component from '@ember/component';
import { action, computed, get, set } from '@ember/object';

/*
attrs
  - filterItem
  - filterSettings = [{
    prop:  '',
    label: '',
    type:  string|number|boolean|select,
    options: [{ label: '', val: '' }]
      - only applies when type is 'select'
  }]
  - removeFilter
    - action

*/

const operationOptions = {
  blank: { label: '', val: '' },
  '===': { label: 'equals', val: '===' },
  '>': { label: 'greater than', val: '>' },
  '>=': { label: 'greater or equal to', val: '>=' },
  '<': { label: 'less than', val: '<' },
  '<=': { label: 'less or equal to', val: '<=' },
  '=~': { label: 'contains', val: '=~' },
  '[]': { label: 'is', val: '[]' },
};

const filterOptionsByType = {
  string: [
    operationOptions['blank'],
    operationOptions['=~'],
    operationOptions['==='],
  ],
  number: [
    operationOptions['blank'],
    operationOptions['==='],
    operationOptions['>'],
    operationOptions['>='],
    operationOptions['<'],
    operationOptions['<='],
  ],
  boolean: [operationOptions['blank'], operationOptions['===']],
  select: [operationOptions['[]']],
};

export default Component.extend({
  filterItem: {},
  filterSettings: null,

  filterSettingsByProp: computed('filterSettings.[]', function () {
    let byProp = {};
    this.filterSettings.forEach((setting) => {
      byProp[get(setting, 'prop')] = setting;
    });
    return byProp;
  }),

  propertyOptions: computed(function () {
    return [{ label: '', val: '' }].concat(
      this.filterSettings.map((x) => {
        return { label: x.label, val: x.prop };
      }),
    );
  }),

  selectedPropType: computed('filterItem.prop', function () {
    let selectedProp = get(this, 'filterItem.prop');
    let setting = this.filterSettingsByProp[selectedProp];
    return setting ? setting.type : null;
  }),

  operationOptions: computed('selectedPropType', function () {
    let selectedPropType = this.selectedPropType;
    return selectedPropType ? filterOptionsByType[selectedPropType] : [];
  }),

  selectedFilterSettingOptions: computed('filterItem.prop', function () {
    let selectedProp = get(this, 'filterItem.prop');
    let setting = this.filterSettingsByProp[selectedProp];
    return [{ label: '', val: '' }].concat(setting.options);
  }),

  handlePropChanged: action(function (newProp) {
    let filterSetting = this.filterSettingsByProp[newProp];
    set(this, 'filterItem.val', '');
    set(this, 'filterItem.op', filterOptionsByType[filterSetting.type][0].val);
  }),

  handleRemove: action(function () {
    this.removeFilter();
  }),
});
